import { cognitoUserData } from "./cognito_user_data";

/**
 * Genera los encabezados necesarios para realizar solicitudes autenticadas, obteniendo los tokens
 * desde los datos del usuario autenticado en Cognito.
 *
 * @param disableAccessToken - Si es `true`, no se incluirá el encabezado `access-token`. Por defecto, se envía.
 * @returns Un objeto con los encabezados `Authorization` e (opcionalmente) `access-token`.
 * @throws Error si los datos del usuario o los tokens no están disponibles.
 */
export const headers_get = async (disableAccessToken = false) => {
  // Obtiene los datos del usuario autenticado
  const userData = await cognitoUserData();

  // Verifica que los datos y los tokens estén disponibles
  if (!userData || !userData.tokens) {
    throw new Error("User data or tokens are not available");
  }

  // Extrae los tokens necesarios
  const { idToken, accessToken } = userData.tokens;

  // Construye los encabezados base
  const headers: Record<string, string> = {
    Authorization: idToken, // Token de identificación para autorización
  };

  // Agrega el access-token solo si disableAccessToken es `false`
  if (!disableAccessToken) {
    headers["access-token"] = accessToken;
  }

  return headers;
};
